app.controller('testTicketIndexCtrl', [
    '$scope', '$rootScope', '$http', 'mdContentService', function ($scope, $rootScope, $http, mdContentService) {
    	var vm = this;

        vm.ymdZeroPadNumber = function(num) {
            var str = "" + num;
            if (str.length == 1) {
                return "0" + str;
            }
            return str;
        }

        vm.getYMD = function() {
            var date = new Date();
            var y = date.getYear() + 1900;
            var m = date.getMonth() + 1;
            var d = date.getDate();
            return "" + y + vm.ymdZeroPadNumber(m) + vm.ymdZeroPadNumber(d);
        }

        vm.genTeacherName = function(minLen, maxLen) {
            var Cstart = 'A'.charCodeAt();
            var Cend = 'Z'.charCodeAt();
            var Clen = Cend - Cstart;

            var Lstart = 'a'.charCodeAt();
            var Lend = 'z'.charCodeAt();
            var Llen = Lend - Lstart;

            var len = Math.floor(Math.random() * (maxLen - minLen)) + minLen;

            var name = "";
            for (var i = 0; i < len; i++) {
                if (i == 0) {
                    var c = Cstart + Math.floor(Math.random() * Clen);
                    name += String.fromCharCode(c);
                } else {
                    var c = Lstart + Math.floor(Math.random() * Llen);
                    name += String.fromCharCode(c);
                }
            }
            return name;
        }

        vm.genTeacherFullName = function() {
            var firstName = vm.genTeacherName(3, 15);
            var lastName = vm.genTeacherName(3, 10);
            return firstName + " " + lastName;
        }

        vm.genRandom = function(minLen, maxLen) {
            var Cstart = 'A'.charCodeAt();
            var Cend = 'Z'.charCodeAt();
            var Clen = Cend - Cstart;

            var Lstart = 'a'.charCodeAt();
            var Lend = 'z'.charCodeAt();
            var Llen = Lend - Lstart;

            var Nstart = '0'.charCodeAt();
            var Nend = '9'.charCodeAt();
            var Nlen = Nend - Nstart;

            var random = "";
            var len = Math.floor(Math.random() * (maxLen - minLen)) + minLen;
            for (var i = 0; i < len; i++) {
                var kind = Math.floor(Math.random() * 3);
                if (kind == 0) {
                    var c = Cstart + Math.floor(Math.random() * Clen);
                    random += String.fromCharCode(c);
                } else if (kind == 1) {
                    var c = Lstart + Math.floor(Math.random() * Llen);
                    random += String.fromCharCode(c);
                } else if (kind == 2) {
                    var c = Nstart + Math.floor(Math.random() * Nlen);
                    random += String.fromCharCode(c);
                }
            }
            return random;
        }

        vm.genUrl = function(key, schoolCategory) {
            var origin = window.location.origin;
            var ymd = vm.getYMD();
            var visualId = vm.genRandom(3, 25);
            var orderNo = vm.genRandom(3, 25);
            var teacherName = vm.genTeacherFullName();

            return origin +
                "/login?key=" + encodeURIComponent(key) + 
                "&startdayymd=" + encodeURIComponent(ymd) +
                "&visualid=" + encodeURIComponent(visualId) +
                "&orderno=" + encodeURIComponent(orderNo) +
                "&teacherName=" + encodeURIComponent(teacherName) +
                "&schoolcategory=" + encodeURIComponent(schoolCategory);
        }

        vm.regenWithKey = function(key) {
            vm.testTicket46 = vm.genUrl(key, "1");
            vm.testTicket79 = vm.genUrl(key, "2");
        }

        vm.regen = function() {
            vm.regenWithKey(vm.key);
        }

        $http.get('/api/gamedayvalidationkey').then(function(response) {
            vm.loaded = true;
            vm.key = response.data.key;
            
            vm.regen();

            mdContentService.triggerSyntheticScrollEvent();
        });
    }
]);